import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';

export interface trackingNumberInterface {
    id: number
    createdAt: string
    updatedAt: string
    number: string
    carrier: string
    deliveredAt: string
    eta: string
    url: string
    packageIdentifier: string
    status?: string
}

export default (axios: AxiosInstance = baseAxios): { markAsDelivered: (trackingNumberId: number) => Promise<void>; } => ({
    markAsDelivered: (trackingNumberId: number): Promise<void> => {
        return axios.post(`/api/trackingNumbers/${trackingNumberId}/markAsDelivered`);
    },
});
